import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { HeadlineTextLarge, TitleTextLarge } from 'Packages/FacetDesign/Components';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
    _customProps: {
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly, { ordinal: 200 })
  .nameOverride(['originAccountName', 'destinationAccountName', 'originAccountNumber', 'destinationAccountNumber', 'secondaryDestinationAccountNumber'], {
    _component: () => TitleTextLarge,
  }, overrideReadOnly)
  .nameOverride('mainContentTitle', {
    _component: () => HeadlineTextLarge,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('disclaimer', {
    _component: () => Richtext,
    _customProps: {
      align: 'center',
      color: 'textDisabled',
      size: 'sm',
    },
  }, overrideReadOnly);
